import {OnErrorDefaultBox} from "./on-error-default.box";

export const OnErrorBox = OnErrorDefaultBox;
